import { useContext, useEffect } from 'react';

import HeadingContext, { type Heading } from './index';

type UseRegisterHeadingOptions = Heading & {
	enabled?: boolean;
};

export const useRegisterHeading = ({
	id,
	depth,
	value,
	enabled = true,
}: UseRegisterHeadingOptions): void => {
	const { addHeading, removeHeading } = useContext(HeadingContext);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		const heading = { id, depth, value };
		addHeading(heading);

		return () => removeHeading(heading);
	}, [addHeading, depth, enabled, id, removeHeading, value]);
};
